// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"a8ee30e4","122":"70aae261","162":"a8ee30e4","283":"70aae261","620":"70aae261","788":"a8ee30e4","864":"70aae261","987":"70aae261"}[chunkId] + ".chunk.css";
};